import styled from 'styled-components';

import { DawnMenuMore } from '@xemplo/icons';

export const NoPointerIcon = styled(DawnMenuMore)`
  pointer-events: none;
`;
